type BuildPageHrefParams = {
  path: string
  page: number
  query?: Record<string, string | number | null | undefined>
  hash?: string
}

const buildPageHref = ({
  path,
  page,
  query = {},
  hash,
}: BuildPageHrefParams): string => {
  const params = new URLSearchParams()

  Object.entries(query).forEach(([key, value]) => {
    if (key === 'page' || value == null || value === '') {
      return
    }

    params.set(key, String(value))
  })

  if (page > 1) {
    params.set('page', String(page))
  }

  const queryString = params.toString()
  const href = queryString ? `${path}?${queryString}` : path
  const normalizedHash = hash?.replace(/^#/, '')

  return normalizedHash ? `${href}#${normalizedHash}` : href
}

export default buildPageHref
